var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-modal",
    {
      staticClass: "modalAvocar",
      attrs: {
        titulo: "Atenção",
        width: 550,
        headerStyle: { backgroundColor: "#ffffff" },
        titleStyle: { color: "#000000 !important", fontWeight: "normal" }
      },
      on: { closeModal: _vm.closeModal }
    },
    [
      _c("template", { slot: "body" }, [
        _c("span", { staticClass: "titulo" }, [
          _c("span", { staticClass: "icone" }, [
            _c("i", {
              staticClass: "fas fa-exclamation-circle",
              staticStyle: { color: "#ed8e07" }
            })
          ]),
          _c("span", [
            _vm._v(
              "  A análise automatizada não está pronta para ser realizada. Deseja continuar para a análise manual?"
            )
          ])
        ])
      ]),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          { staticClass: "flex" },
          [
            _c(
              "el-button",
              {
                staticClass: "btn",
                attrs: { id: "cancelarAvocar", type: "default", size: "small" },
                on: {
                  click: function($event) {
                    return _vm.closeModal()
                  }
                }
              },
              [
                _c("span", { staticClass: "center" }, [
                  _c("i", { staticClass: "el-icon fas fa-times" }),
                  _c("b", [_vm._v("  Cancelar")])
                ])
              ]
            ),
            _c(
              "el-button",
              {
                staticClass: "btn",
                attrs: {
                  id: "confirmarAvocar",
                  type: "success",
                  size: "small"
                },
                on: { click: _vm.finalizar }
              },
              [
                _c("span", { staticClass: "center" }, [
                  _c("i", { staticClass: "el-icon fas fa-check" }),
                  _c("b", [_vm._v("  Confirmar")])
                ])
              ]
            )
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cb96a838", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb96a838","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/components/modal/AppModalContinuarAnaliseManual.vue
// module id = null
// module chunks = 